<template>
  <div class="box">
    <div class="head">
      <Header></Header>
    </div>
    <!-- 视频页面 -->
    <div class="div">
      <h2>{{ now.title }}</h2>
      <div>{{ now.time }}</div>
      <div>
        <video
          width="80%"
          controls
          :src="now.src"
          preload="auto"
          webkit-playsinline="true"
          x5-video-player-type="h5"
        ></video>
      </div>
    </div>
    <div class="foot">
      <Footer></Footer>
    </div>
  </div>
</template>

<script>
import Header from "@/views/header/Header.vue";
import Footer from "@/views/footer/Footer.vue";
export default {
  components: { Header, Footer },
  data() {
    return {
      activeName: "two",
      text: "行业资讯",
      now: {},
      tableData: [
        {
          title: "都说企业停产、人宅家，那污染从哪里来？",
          time: "2020-12-01 \xa0\xa0\xa0\xa0\xa0 来源：国家大气污染防治攻关联合中心",
          // src: require("../../../assets/images/dynamicInformation/video/video001.mp4"),
          src: "http://49.4.68.154/video/video001.mp4",
        },
        {
          title: "中国大气污染治理历程",
          time: "2022-04-01 \xa0\xa0\xa0\xa0\xa0 来源：国家大气污染防治攻关联合中心",
          src: "http://49.4.68.154/video/video002.mp4",
        },
        {
          title: "泄漏检测与修复(LDAR)的现状和发展",
          time: "2022-04-01 \xa0\xa0\xa0\xa0\xa0 来源：环保大讲坛",
          src: "http://49.4.68.154/video/video003.mp4",
        },
        {
          title: "“环保管家”工作内容如何从“虚”向“实”",
          time: "2022-04-01 \xa0\xa0\xa0\xa0\xa0 来源：环保大讲坛",
          src: "http://49.4.68.154/video/video004.mp4",
        },
        {
          title: "石化企业VOCs要点解读",
          time: "2022-04-01 \xa0\xa0\xa0\xa0\xa0 来源：环保大讲坛",
          src: "http://49.4.68.154/video/video005.mp4",
        },
        // {
        //   title: "环保讲坛，以智能管理助力环保行业",
        //   time: "2022-04-01 \xa0\xa0\xa0\xa0\xa0  来源：环保大讲坛",
        //   src: "http://49.4.68.154/video/video003.mp4",
        // },
        // {
        //   title: "“一企(厂)一策”开展方法和实例分析",
        //   time: "2022-04-01 \xa0\xa0\xa0\xa0\xa0 来源：环保大讲坛",
        //   src: "http://49.4.68.154/video/video007.mp4",
        // },
      ],
    };
  },
  created() {
    this.$store.state.menu = 5;
    // console.log(this.$route.query.id);
  },
  mounted() {
    this.query();
  },

  methods: {
    handleClick() {
      this.active = 0;
    },
    query() {
      //   console.log("传参", this.$route.query.id);
      this.now = this.tableData[this.$route.query.id];
    },
  },
};
</script>
<style lang="scss" scoped>
.box {
  .head {
    position: fixed;
    width: 100%;
    height: 100px;
    background-color: #fff;
    z-index: 5;
    color: #333;
    box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.2);
  }
  .div {
    padding: 0 360px;
    padding-top: 100px;
    h2 {
      font-size: 31px;
      color: #333;
      text-align: center;
    }
    div:nth-child(2) {
      font-size: 16px;
      color: #666;
      margin-bottom: 20px;
      padding-bottom: 10px;
      border-bottom: 1px solid #afc4d1;
    }
    div:nth-child(3) {
      text-align: center;
      padding-bottom: 50px;
      border-bottom: 1px solid #afc4d1;
    }
  }
  .crumbs {
    position: absolute;
    right: 360px;
    line-height: 40px;
    z-index: 2;
    color: #fff;
    font-size: 16px;
  }
  .router-link-active {
    text-decoration: none;
    color: #fff;
  }
  // tabs标题的字号
  /deep/ .el-tabs__item {
    font-size: 16px;
  }
}
</style>
